import { useState, useEffect, forwardRef } from "react";
import "./../style/Title.scss";
import pdf from "./../resume.pdf";

const Title = forwardRef(({ activePage: propActivePage, hidden }, ref) => {
  const [activePage, setActivePage] = useState("home");

  useEffect(() => {
    if (propActivePage !== activePage) {
      const titleEl = document.querySelector(".title");
      if (titleEl) {
        titleEl.classList.add("titleFadeOut");
        setTimeout(() => {
          setActivePage(propActivePage);
        }, 150);
      }
    } else {
      const titleEl = document.querySelector(".title");
      if (titleEl) {
        titleEl.classList.remove("titleFadeOut");
      }
    }
  });

  return (
    <div className={`titleContainer ${hidden ? 'hidden' : ''}`} ref={ref}>
      <h1 className="title" key={propActivePage}>
        {activePage}
      </h1>
      <a href={pdf} className="resume" target="_blank" rel="noreferrer">
        Resume
      </a>
    </div>
  );
});

export default Title;
